import {Component, OnInit} from '@angular/core';
import {DocumentSigningService} from "../../_services/document-signing.service";
import {SessionService} from "../../_services/session.service";
import {ActivatedRoute, Router} from "@angular/router";
import {AppComponent} from "../../app.component";
import {AppConfig} from "../../app.config";
import {AuthenticactionService} from "../../_services/authentication.service";

@Component({
    selector: 'app-document-signing',
    templateUrl: './document-signing.component.html',
    styleUrls: ['./document-signing.component.scss']
})
export class DocumentSigningComponent implements OnInit {

    private _show = false;
    private _responseParams;
    constructor(
        public documentSigningService: DocumentSigningService,
        private activatedRouteService: ActivatedRoute,
        private authService: AuthenticactionService,
        private sessionService: SessionService,
        private router: Router
    ) {
    }

    async ngOnInit(): Promise<void> {
        this.responseParams = await this.getResponseParams();
        await this.checkResponseToken(this.responseParams);
        await this.getSystemTokens(this.responseParams);
        await this.checkSessions([AppConfig.ID_SESSION_TOKEN, AppConfig.CLERK_DATA]);
        this.show = true;
    }

    private async getResponseParams() {
        return this.activatedRouteService.snapshot.queryParamMap['params'];
    }

    private async checkResponseToken(params) {
        const sessionToken = this.sessionService.getItem(AppConfig.ID_SESSION_TOKEN);
        const responseToken = params['state'];

        if (sessionToken == null || responseToken == null){
            await this.logout();
        }

        if ( sessionToken !== null && (sessionToken.toString() !== responseToken.toString())){
            await this.logout();
        }
    }

    private async getSystemTokens(params) {
        const codes = {
            code: params['code'],
            state: params['state'],
        }
        const allData = await this.documentSigningService.getInfo(codes);
        if (allData['internal_data']){
            this.authService.login3(allData);
        }
    }

    private async checkUOHClerk(){

    }

    private async checkSessions(sessions = []){
        let count: number = 0;
        sessions.forEach(session => {
            if (this.sessionService.exist(session)) {
                count++;
            }
        });
        if (count !== sessions.length) {
            await this.logout();
        }
    }

    private async redirectToHome(){
        await this.router.navigate(['']);
    }

    private async logout(){
        await this.authService.logoutAll();
        await this.redirectToHome();
    }

    get responseParams() {
        return this._responseParams;
    }
    set responseParams(value) {
        this._responseParams = value;
    }
    get show() {
        return this._show;
    }
    set show(value) {
        this._show = value;
    }
}
